<div class="auth-form-card">
  <div class="auth-form-header">
    <img
      src="/assets/logos/cyflare-one-logo-new-colors.png"
      alt="Cyflare One"
      class="auth-form-logo"
    />
    <h2>Reset Password</h2>
  </div>

  <form [formGroup]="passwordForm">
    <div class="auth-form-field">
      <kendo-floatinglabel text="New Password">
        <input
          kendoTextBox
          required
          formControlName="password"
          type="password"
          class="form-control"
        />
      </kendo-floatinglabel>
    </div>

    <div class="auth-form-field">
      <kendo-floatinglabel text="Confirm New Password">
        <input
          kendoTextBox
          required
          formControlName="confirmPassword"
          type="password"
          class="form-control"
        />
      </kendo-floatinglabel>

      @if (passwordForm.hasError('mismatch') && (passwordForm.get('confirmPassword')?.touched || passwordForm.get('confirmPassword')?.dirty)) {
        <p class="auth-form-error">Passwords do not match</p>
      }
    </div>

    <div class="auth-form-submit">
      <button
        kendoButton
        class="cyflare-btn-primary cyflare-btn-lg cyflare-btn-block"
        type="button"
        (click)="resetPassword($event)"
        [disabled]="passwordForm.invalid"
      >
        Update and Sign In
      </button>
      <kendo-formhint class="auth-form-hint">
        Password Must Contain:<br />- Minimum of 10 characters<br />- At least one uppercase character<br />- At least one lowercase character<br />- At least one number<br />- At least one special character (no spaces allowed)
      </kendo-formhint>
    </div>

    <div class="auth-form-footer">
      <span>Having trouble signing in?</span>
      <a
        href="mailto:support@cyflare.com"
        kendoButton
        fillMode="clear"
      >
        Contact Us
      </a>
    </div>

    <div class="auth-form-secondary">
      <button
        kendoButton
        class="cyflare-btn-secondary cyflare-btn-lg cyflare-btn-block"
        type="button"
        (click)="back()"
      >
        Go Back
      </button>
    </div>
  </form>
</div>
